var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconMenuAccountFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.007 19.01c-1.329-1.318-4.166-2.647-5.507-3.385a.994.994 0 01-.234-1.551c1.39-1.477 2.726-2.732 2.726-6.068C21.992 5.003 19.987 2 15.988 2c-4 0-6.005 3.003-6.005 6.006 0 3.335 1.36 4.579 2.75 6.068a.994.994 0 01-.233 1.55c-1.341.74-4.202 2.068-5.531 3.385C5.32 20.683 5.049 24.474 5 28.006a1.988 1.988 0 001.993 2.006h18.014A1.988 1.988 0 0027 28.006c-.05-3.532-.32-7.31-1.993-8.997z",
    fill: "#228622"
  })));
}

export default SvgIconMenuAccountFilled;